<template>


    <div class="PhotoCenter" :visible.sync="photoCenterShow">
      <el-dialog
            :visible.sync="photoCenterShow"
            :before-close="handleDialogClose"
            :show-close="false"
            :destroy-on-close="true">
            <i class="el-icon-close" @click="closeDialog"></i>
            <div class="top-segment">
            <el-tabs  @tab-click="handleClick">
                <el-tab-pane label="上传图片或视频" name="first">

                </el-tab-pane>
                <el-tab-pane :label="source_type==SourceType.NoLimited?'选择图片或视频':source_type==SourceType.Image?'选择图片':'选择视频'" name="second">

                </el-tab-pane>
            </el-tabs>
          </div>
          <div class="bottom-pannel">
                <photo-pick :source_type="source_type" :maxselected_num="maxselected_num" v-if="optype_v==op_type.select_model" @cancel_pick="cancel_pick"></photo-pick>
                <photo-upload v-else-if="optype_v==op_type.upload_model"></photo-upload>
          </div>
      </el-dialog>


       
    </div>
  </template>
  
<script>
  const op_type = {
      upload_model:'0',
      select_model:'1'
  }
import { PhotoChooseType, SourceType } from '../../system/config.js';
  import PhotoPick from './PhotoPick.vue';
  import PhotoUpload from './PhotoUpload.vue';

    export default {
     name: 'photo-center',
     components:{
        PhotoPick,
        PhotoUpload
     },
      props:{
        photoCenterShow:{
            type:Boolean,
            default:false
        },
        maxselected_num:{
            type:Number,
            default:1
        },
        source_type:{
          type:Number,
          default:SourceType.NoLimited
        }
      },
      data() {
        return {
          SourceType,
          op_type,
          optype_v:op_type.upload_model
        };
      },
     
      mounted(){
        
      },

      computed: {
       
      },
      watch:{
        
        
      },
      methods: {
        handleClick(e){
            //切换类型
            console.log(e)
            const index = e._data.index;
            this.optype_v = index
        },
        handleDialogClose(e){
          console.log('handleDialogClose',e)
            // this.photoCenterShow = false;
        },
        closeDialog(){
          // this.photoCenterShow = false
          this.$emit('closeDialog');
        },
        cancel_pick(){
          this.$emit('closeDialog');
        }
      },
    };
  </script>
  
  <style lang="less" src="./PhotoCenter.less"></style>
  